var map = {
	"./en.json": [
		783,
		11
	],
	"./es-CO.json": [
		784,
		12
	],
	"./fr.json": [
		785,
		13
	],
	"./ko.json": [
		786,
		14
	],
	"./pt-BR.json": [
		787,
		15
	],
	"./th.json": [
		788,
		16
	],
	"./vi.json": [
		789,
		17
	],
	"./zh-CN.json": [
		790,
		18
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 776;
module.exports = webpackAsyncContext;